import axios from "axios";
import url from "@/utils/api/url";

const URL_BASE = url.URL_API + '/base';

// 与数据库字典相关的URL
const URL_BASE_CODE = URL_BASE + '/code';
const URL_BASE_CODE_TYPE = URL_BASE + '/code/type';

// 与省市区相关的URL
const URL_BASE_REGION_PROVINCE = URL_BASE + '/region/province';
const URL_BASE_REGION_CITY = URL_BASE + '/region/city';
const URL_BASE_REGION_PROVINCE_CITY = URL_BASE + '/region/provinceCity';

// 与职业院校专业及专业分类相关的URL
const URL_BASE_FACULTY_CATEGORY = URL_BASE + '/faculty/category';
const URL_BASE_FACULTY_FACULTY = URL_BASE + '/faculty/faculty';
const URL_BASE_FACULTY_CATEGORY_FACULTY = URL_BASE + '/faculty/categoryFaculty';


export default {
    code: {
        getCodeDataByCodeTypeId(codeTypeId) {
            return axios.get(URL_BASE_CODE, {params: {codeTypeId: codeTypeId}});
        },
        insertCode(codeInfo) {
            return axios.post(URL_BASE_CODE, codeInfo);
        },
        deleteCode(codeTypeId, codeValue) {
            return axios.delete(URL_BASE_CODE + '/' + codeTypeId + '/' + codeValue);
        }
    },
    codeType: {
        getAllCodeTypeData() {
            return axios.get(URL_BASE_CODE_TYPE);
        },
        getCodeTypeById(codeTypeId) {
            return axios.get(URL_BASE_CODE_TYPE + '/' + codeTypeId);
        },
        insertCodeType(codeTypeInfo) {
            return axios.post(URL_BASE_CODE_TYPE, codeTypeInfo);
        },
        updateCodeType(codeTypeInfo) {
            return axios.put(URL_BASE_CODE_TYPE + '/' + codeTypeInfo.codeTypeId, codeTypeInfo);
        },
        deleteCodeType(codeTypeId) {
            return axios.delete(URL_BASE_CODE_TYPE + '/' + codeTypeId);
        },
    },
    codeValue: {
        getCodeByCodeTypeId(codeTypeId) {
            return axios.get(URL_BASE_CODE, {params: {codeTypeId: codeTypeId}});
        },

        //region 班级状态相关
        getBaseClassStateEnum() {
            return this.getCodeByCodeTypeId('PROJECT_CLASS_STATE_ENUM');
        },
        //endregion 班级状态相关

        //region 项目状态相关
        getBaseProjectStateEnum() {
            return this.getCodeByCodeTypeId('PROJECT_PROJECT_STATE_ENUM');
        },
        //endregion 项目状态相关

        //region 项目层级相关
        getBaseProjectLevelEnum() {
            return this.getCodeByCodeTypeId('PROJECT_PROJECT_LEVEL_ENUM');
        },
        //endregion 项目层级相关

        //region 基础数据相关数据字典
        getBaseChinaAreaEnum() {
            return this.getCodeByCodeTypeId('BASE_CHINA_AREA_ENUM');
        },
        getBaseCollegeLevelEnum() {
            return this.getCodeByCodeTypeId('BASE_COLLEGE_LEVEL_ENUM');
        },
        //endregion

        //region Common
        getCourseCategoryEnum() {
            return this.getCodeByCodeTypeId('COMMON_COURSE_CATEGORY_ENUM');
        },
        //endregion

        //region 用户相关数据字典
        getUserRuleTypeEnum() {
            return this.getCodeByCodeTypeId('USER_RULE_TYPE_ENUM');
        },

        getUserGenderEnum() {
            return this.getCodeByCodeTypeId('USER_GENDER_ENUM');
        },
        getUserPersonTypeEnum() {
            return this.getCodeByCodeTypeId('USER_PERSON_TYPE_ENUM');
        },
        getUserDegreeTypeEnum() {
            return this.getCodeByCodeTypeId('USER_DEGREE_TYPE_ENUM');
        },
        getUserEducationTypeEnum() {
            return this.getCodeByCodeTypeId('USER_EDUCATION_TYPE_ENUM');
        },
        getUserNationEnum() {
            return this.getCodeByCodeTypeId('USER_NATION_ENUM');
        },
        getUserPoliticalOutlookEnum() {
            return this.getCodeByCodeTypeId('USER_POLITICAL_OUTLOOK_ENUM');
        },

        getUserStudentStateEnum() {
            return this.getCodeByCodeTypeId('USER_STUDENT_STATE_ENUM');
        },
        //endregion

        getProjectClassScheduleDatePartEnum() {
            return this.getCodeByCodeTypeId('PROJECT_CLASS_SCHEDULE_DATE_PART_ENUM');
        },

        getSurveyTemplateTypeEnum() {
            return this.getCodeByCodeTypeId('STUDY_SURVEY_TEMPLATE_TYPE_ENUM');
        },
        getSurveyTemplateItemTypeEnum() {
            return this.getCodeByCodeTypeId('STUDY_SURVEY_TEMPLATE_ITEM_TYPE_ENUM');
        },
        getSurveyPaperStateEnum() {
            return this.getCodeByCodeTypeId('STUDY_SURVEY_PAPER_STATE_ENUM');
        },
    },

    region: {
        getProvinceData() {
            return axios.get(URL_BASE_REGION_PROVINCE);
        },
        getCityData(provinceId) {
            return axios.get(URL_BASE_REGION_CITY, {params: {provinceId}});
        },
        getProvinceCityData() {
            return axios.get(URL_BASE_REGION_PROVINCE_CITY);
        },
        getLiaoningCityData() {
            return axios.get(URL_BASE_REGION_CITY, {params: {provinceId: '210000'}});
        }
    },

    faculty: {
        getFacultyCategoryData(collegeLevel) {
            return axios.get(URL_BASE_FACULTY_CATEGORY, {params: {collegeLevel}});
        },
        getFacultyData(filterCategoryId) {
            return axios.get(URL_BASE_FACULTY_FACULTY, {params: {filterCategoryId}});
        },
        getFacultyWithCategoryData(collegeLevel) {
            return axios.get(URL_BASE_FACULTY_CATEGORY_FACULTY, {params: {collegeLevel}});
        },
        getFacultyByFirCategory(firCategoryId) {
            return axios.get(URL_BASE_FACULTY_FACULTY + '/firCategory', {params: {firCategoryId}});
        }
    },
}
